import {useEffect, useState} from 'react';
import {Text} from '@esgi/ui/typography';
import {
	HeaderLabel,
	HeaderRow,
	IconBox,
	IndicatorWrapper,
	ItemTagAndTitle,
	NotTestedCounter,
	Options,
	SelectableListGroup,
	SelectableListGroupRoot,
	SelectableListRoot,
	SelectableListTrigger,
	SelectableListTriggerContent,
	Tag,
	TagList,
	TestColorIndicator,
	TestTypeLabel,
	TriggerWrapper,
} from '../../index.styled';
import {AccordionCollapse, AccordionExpand, CorrectAnswer, InCorrectAnswer} from '@esgi/ui';
import {StudentListItem} from './components/student-item';
import {StudentItem, TestItem, TestListDataItem} from '@esgi/main/features/untested-students-report';
import {TestType} from '@esgi/main/libs/core';
import {StudentModel} from '@esgi/main/features/assessments';
import {Box} from '@esgi/ui/layout';

interface Props {
	test: TestListDataItem,
	showAllStudents: boolean;
	isDisabled?: boolean;
	onStartTest: (test: TestItem, student: StudentModel) => void;
}

export function TestList(props: Props) {
	const {
		test,
		isDisabled,
	} = props;

	const [isItemOpen, setItemOpen] = useState(true);

	useEffect(() => {
		setItemOpen(false);
	}, [props.showAllStudents]);

	const onTestStart = (student: StudentItem) => {
		const studentModel: StudentModel = {
			firstName: student.firstName,
			lastName: student.lastName,
			gradeLevelID: 0,
			hasCredentials: false,
			id: student.id,
			photoUrl: '',
			languageID: student.languageID,
		};

		const testModel: TestItem = {
			contentArea: test.contentArea,
			id: test.id,
			name: test.name,
			type: test.type,
			creatorID: 0,
			color: '',
			isWhiteBackground: false,
			testScreenTypes: [],
			maxScore: student.maxScore,
			untested: student.untested,
			incorrect: student.incorrect,
			correct: student.correct,
		};
		props.onStartTest(testModel, studentModel);
	};

	const ResultsComponent = () => {
		return isItemOpen ? <TagList>
				{test.type === TestType.YN && <>
					<Tag type='green'>
						<CorrectAnswer/>
					</Tag>
					<Tag type='red'>
							<InCorrectAnswer/>
					</Tag>
					<Tag>
						<Text size='xxSmall' font='mono' color='neutral64'>NT</Text>
					</Tag>
				</>}
			</TagList>
			: <NotTestedCounter>
				{test.notTested === 0 ? <><Box /><Text size='small' color='green48'>All tested</Text></> : <>
					<Tag>
						<Text size='xxSmall' font='mono' color='neutral64'>{test.notTested}</Text>
					</Tag>
					<Text size='small' color='neutral80'>Not tested</Text>
				</>}
			</NotTestedCounter>;
	};

	return <SelectableListRoot isListOpen={isItemOpen} onListOpenChange={setItemOpen}>
		<SelectableListGroupRoot>
			<HeaderRow onClick={() => setItemOpen(prev => !prev)} isListOpen={isItemOpen}>
				<ItemTagAndTitle>
					<SelectableListTriggerContent>
						<TestColorIndicator testID={test.id}/>
						<HeaderLabel size='large' isListOpen={isItemOpen}>{test.name}</HeaderLabel>
						<TestTypeLabel>{test.type === TestType.YN ? 'Yes or No' : String(test.type)}</TestTypeLabel>
					</SelectableListTriggerContent>
				</ItemTagAndTitle>

				<Options>
					<IconBox>
						{isDisabled
							? <Text size='small' color='neutral80'>No Results</Text>
							: <ResultsComponent />
						}
					</IconBox>
					<TriggerWrapper>
						<SelectableListTrigger isListOpen={isItemOpen}>
							<IndicatorWrapper>
								{isItemOpen ? <AccordionCollapse /> : <AccordionExpand />}
							</IndicatorWrapper>
						</SelectableListTrigger>
					</TriggerWrapper>
				</Options>

			</HeaderRow>
			<SelectableListGroup>
				{!isDisabled && <StudentListItem onStartTest={onTestStart} students={test.students} testId={test.id} testType={test.type}/>}
			</SelectableListGroup>
		</SelectableListGroupRoot>
	</SelectableListRoot>;
}

